<template>
	<div :class="['param-wrapper-container', { 'is-disabled': disabled }]">
		<v-row id="form_input_field" no-gutters class="text-left fif px-0 pt-2">
			<v-col cols="12" class="text-left" style="position: relative">
				<slot name="title" v-if="!hideTitle">
					<ParamTitle :param="param" :node="node" :showParamMetadata="showParamMetadata" :isFocused="isFocused" />
				</slot>
				<slot />
				<p v-if="showParamMetadata && !hideMetadata && param.extra_text" :class="extraParamsClass">
					{{ param.extra_text }}
				</p>
				<transition name="fromBottomMenu" mode="out-in" v-if="!readonly">
					<div class="insert-data-container" v-click-outside="{ handler: onClickOutside, include: getAbsoluteMenuElements }">
						<slot name="input-data" :param="param" />
					</div>
				</transition>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import ParamTitle from './ParamTitle';
import DataInputMenuService from '../../../../DataInput/DataInputMenu/data-input-menu-service';
import { isFeatureOn } from '@/store/modules/featureFlags/getters';
import { FEATURE_FLAGS } from '@/utils/feature-toggle-service';

export default {
	name: 'ParamWrapper',
	props: {
		node: { type: Object },
		param: { type: Object },
		showDataMenu: { type: Boolean, default: false },
		hideTitle: { type: Boolean, default: false },
		hideMetadata: { type: Boolean, default: false },
		inputElement: { type: [Object, HTMLDivElement] },
		isFocused: { type: Boolean },
		readonly: { type: Boolean },
		useExtraParamsAsTitle: { type: Boolean },
		disabled: { type: Boolean },
	},
	components: { ParamTitle },
	computed: {
		...mapGetters([isFeatureOn.fullPath]),
		showParamMetadata() {
			return !!this[isFeatureOn.fullPath](FEATURE_FLAGS.SHOW_ACTION_PARAM_METADATA);
		},
		extraParamsClass() {
			return this.useExtraParamsAsTitle ? 'font-medium text-[14px] mt-[15px]' : 'mt-1 mb-4 text-caption font-italic';
		},
	},
	methods: {
		onClickOutside() {
			this.$emit('input-data-closed');
		},
		getAbsoluteMenuElements() {
			const elements = DataInputMenuService.getDataInputMenuAbsoluteElements();
			if (this.inputElement) {
				elements.push(this.inputElement);
			}
			return elements;
		},
	},
};
</script>

<style lang="scss" scoped>
.param-wrapper-container {
	margin-bottom: 5px;
}
</style>
